// My kingdom for Ruby's `Enumerable#each_slice`
export default number => {
  const [int, decimal] = number.split('.');

  const commafied = int
    .toString()
    .split('')
    .reverse()
    .map((d, index) => ((index + 1) % 3 === 0 ? `,${d}` : d))
    .reverse()
    .join('')
    .replace(/^,|,$/, '');

  return `${commafied}${decimal ? `.${decimal}` : ''}`;
};
